export default {
  appTitle: 'ペット健康管理システム',
  appSubtitle: '🐾 あなたのデジタルペットケアパートナー',
  createPetProfileDesc: 'ペットプロフィールを簡単に作成し、健康を追跡し、介護者と安全に情報を共有できます。どこにいても安心してペットをケアできます。',
  getStarted: '始める',
  learnMore: '詳しく見る',
  signUp: '今すぐ登録',

  // Stats
  happyPets: '幸せなペット',
  usersFamilies: 'ユーザー家族',
  careProfiles: 'ケアプロフィール',
  satisfactionRate: '満足度',

  // How It Works
  easiestWay: '最も簡単な方法',
  howItWorks: '使い方',
  howItWorksSubtitle: 'わずか3つの簡単なステップでペットの健康とケアの管理を開始',
  forPetOwners: 'ペットオーナー向け',
  forCaregivers: '介護者向け',

  // Steps for Pet Owners
  createPetProfile: 'ペットプロフィールを作成',
  createPetProfileDesc: '健康記録、食事、ケアニーズを含むペットの詳細情報を追加',
  shareWithCaregivers: '介護者と共有',
  shareWithCaregiversDesc: '家族、友人、プロの介護者とペット情報を安全に共有',
  travelWithPeace: '安心して旅行',
  travelWithPeaceDesc: 'あなたが不在の間もペットが最高のケアを受けていることを知って、安心して旅行',

  // Steps for Caregivers
  accessPetDetails: 'ペットの詳細にアクセス',
  accessPetDetailsDesc: '重要なペット情報とケア指示をすぐに確認',
  followSchedules: 'スケジュールに従う',
  followSchedulesDesc: '給餌時間、薬、その他の重要なケアタスクを追跡',
  stayConnected: '接続を維持',
  stayConnectedDesc: 'ペットオーナーとコミュニケーションを取り、更新を共有',

  // Features
  whyChooseUs: '選ばれる理由',
  features: 'コア機能',
  featuresSubtitle: 'あなたとあなたのペットのために設計された包括的なケアツール',
  
  featureTitle1: '包括的なペットプロフィール',
  featureDesc1: '健康記録、予防接種、薬などを含むすべてのペット情報を保存',
  
  featureTitle2: '安全な共有',
  featureDesc2: '誰が何にアクセスできるかを完全にコントロールして、介護者とペット情報を安全に共有',
  
  featureTitle3: 'リアルタイム更新',
  featureDesc3: 'ペットの健康とケア活動に関する即時通知を受け取る',

  scheduleFeature: 'スケジュール管理',
  scheduleFeatureDesc: '給餌時間、薬、獣医の予約、その他の重要なイベントを追跡',

  healthFeature: '健康追跡',
  healthFeatureDesc: '体重、予防接種、アレルギー、健康状態を監視',

  mobileFeature: 'モバイルフレンドリー',
  mobileFeatureDesc: 'いつでもどこでも、どのデバイスでもペット情報にアクセス',

  viewAllFeatures: 'すべての機能を見る',

  // App Preview
  seamlessExperience: 'シームレスな体験',
  appPreviewTitle: '強力でありながら直感的なインターフェース',
  appPreviewDescription: '私たちのアプリは、ペットケアをシンプルで楽しいものにするように設計されています。すべての機能が指先にあります。',
  
  multiUserAccess: 'マルチユーザーアクセス',
  multiUserAccessDesc: '家族や介護者と協力してペットをケア',
  
  healthTracking: '健康追跡',
  healthTrackingDesc: '体重、予防接種、獣医の訪問を監視',
  
  premiumFeature: 'プレミアム機能',
  premiumFeatureDesc: 'より良いペットケアのための高度なツールをアンロック',

  petDashboard: 'ペットダッシュボード',
  dog: '犬',
  years: '歳',
  healthyStatus: '健康',
  nextFeeding: '次の給餌',
  nextMedication: '次の薬',
  weight: '体重',
  nextVetVisit: '次の獣医訪問',
  profileCompletion: 'プロフィール完成度',
  viewDetails: '詳細を見る',
  updateProfile: 'プロフィールを更新',

  // Testimonials
  happyUsers: '満足しているユーザー',
  testimonials: 'ユーザーの声',
  testimonialsSubtitle: '他のペットオーナーがPet Care Noteについて何と言っているか見てみましょう',

  testimonial1: 'このアプリは私のペットのケア管理を変えました！すべての健康記録を簡単に追跡できます。',
  testimonial1Author: 'サラ・チェン',
  testimonial1Role: '3匹の猫の飼い主',

  testimonial2: 'ペットシッターとして、このアプリは私の仕事をとても簡単にしてくれます。必要な情報がすべて1か所にあります！',
  testimonial2Author: 'ジョン・スミス',
  testimonial2Role: 'プロのペットシッター',

  testimonial3: 'ついに、私のすべてのペットケアニーズをカバーするアプリが見つかりました。強くお勧めします！',
  testimonial3Author: 'エミリー・ジョンソン',
  testimonial3Role: '2匹の犬の飼い主',

  testimonial4: '共有機能は、家族とペットケアを調整するのに最適です。',
  testimonial4Author: 'マイケル・リー',
  testimonial4Role: '家族のペット飼い主',

  testimonial5: '私の犬の予防接種と獣医の予約を追跡できるのが大好きです。とても整理されています！',
  testimonial5Author: 'ジェシカ・ブラウン',
  testimonial5Role: '1匹の犬の飼い主',

  testimonial6: 'このアプリは私のペットケアビジネスのゲームチェンジャーです。',
  testimonial6Author: 'デビッド・ウィルソン',
  testimonial6Role: 'ペットケアプロフェッショナル',

  // CTA
  readyToStart: '始める準備はできましたか？',
  ctaTitle: '今日からペット健康の旅を始めましょう',
  ctaDescription: 'Pet Care Noteを信頼して毛むくじゃらの友達をケアしている何千ものペットオーナーに参加してください',

  learnMoreAbout: '詳しく知る',
  aboutUs: '会社概要',
  contactSupport: 'サポートに連絡',
  privacyPolicy: 'プライバシーポリシー',

  // Pet types
  corgi: 'コーギー',
  siameseCat: 'シャム猫',
  borderCollie: 'ボーダーコリー',
  caregiver: '介護者',
  location: '場所',
  home: '自宅',
};